module.exports = __webpack_public_path__ + "img/collection-weddingRingsGold@2x.7e336eb.jpg";